import { render, staticRenderFns } from "./AddUpdateFAQGroup.vue?vue&type=template&id=c1e80eea&"
import script from "./AddUpdateFAQGroup.vue?vue&type=script&lang=js&"
export * from "./AddUpdateFAQGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports